(function() {
  "use strict";

  angular.module("PrinterIdSign")
    .controller("PrinterIdSignController", [
      "$scope", "$location", "PrinterListService", "URLS", "PRINTER_TYPES", 
      "$routeParams", "URL_PARAMS", 'EventHandlerService', 'TenantListService',
      function(
        $scope, $location, PrinterListService, URLS, PRINTER_TYPES, 
        $routeParams, URL_PARAMS, EventHandlerService, TenantListService) {

        $scope.printerList = null;
        $scope.currentDate = new Date().getTime();
        $scope.qrUrlPath = "qrRedirect/printers/";
        $scope.printerListService = PrinterListService;
        $scope.selectPrinterUrlPrefix = $location.protocol() + "://" + $location.host() + "/" + $scope.qrUrlPath;
        $scope.printerTypes = PRINTER_TYPES;
        $scope.eventHandlerService = EventHandlerService;

        (function(){
          initEventHandler();
        })();

        $scope.$watch(function() {
          return TenantListService
        }, function() {
          if (TenantListService.currentTenant) {
            $scope.tenant = TenantListService.currentTenant;
            init()
          }
        }, true);
        
        function initEventHandler() {
          $scope.eventHandlerService.deRegisterListeners();
        };

        function init() {
          if ($routeParams[URL_PARAMS.PRINTER_URL.ROUTE]) {
            var selectedPrinters = [];
            var printerIds = $routeParams[URL_PARAMS.PRINTER_URL.ROUTE].split(",");
            var printerURLS = printerIds.map((id) => {
              return $scope.tenant.info._links['px:printers'].href + "/" + id;
            })
            angular.forEach(printerURLS, function(url) {
              PrinterListService.getPrinterByURL(url).then(function(printer) {
                selectedPrinters.push(printer);
                if (printerURLS.length === selectedPrinters.length) {
                  selectedPrinters.removeWith({
                    info: {
                      type: $scope.printerTypes.FREEDOM
                    }
                  });
                  $scope.printerList = angular.copy(selectedPrinters);
                }
              }).catch(function(error) {});
            });
          } else {
            $location.path(URLS.PRINTER_LIST);
          }
        }

      }
    ]);
})();